<p-toast></p-toast>
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <h5 class="mt-0">{{'WORK_FLOW_ALL_STATUS'| translate}}</h5>
        <div class="card">
            <p-table #workFlowAllStatusTable [value]="workFlowAllStatusModel" [rows]="10" [paginator]="true"
                responsiveLayout="scroll" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loading">
                <ng-template pTemplate="caption">
                    <!-- <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">Work Flow All Status</h5>
                    </div> -->
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="appID">{{'APP_ID'| translate}}
                        </th>
                        <th pSortableColumn="farmerName">{{'ACTION'| translate}}
                        </th>
                        <th pSortableColumn="ApplicantType">{{'LEVEL_ID'| translate}}
                        </th>
                        <th pSortableColumn="NextLevelID">{{'TRAGET_DAYS'| translate}}
                        </th>
                        <th pSortableColumn="Scheme_Code">{{'ASSIGN_DATE'| translate}}
                        </th>
                        <th pSortableColumn="TargetDays">{{'PENDING_COMPLETED'| translate}}
                        </th>
                        <th pSortableColumn="block">{{'STATUS'| translate}}
                        </th>
                        <th pSortableColumn="district">{{'REMARKS'| translate}}
                        </th>
                        <th pSortableColumn="registerationDate">{{'ACTION_DATE'| translate}}
                        </th>
                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.AppID}}</td>
                        <td>{{product.Action}}</td>
                        <td>{{product.LevelID}}</td>
                        <td>{{product.TragetDays}}</td>
                        <td>{{product.AssignDate | date : 'dd/MM/yyyy'}}</td>
                        <td>{{product.PendingCompletedDays}}</td>
                        <td>{{product.Status}}</td>
                        <td>{{product.Remarks}}</td>
                        <td>{{product.ActionDate |  date : 'dd/MM/yyyy'}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{workFlowAllStatusModel ? workFlowAllStatusModel.length : 0 }} {{'STATUS_ADDED' | translate}}.
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>
